<div class="block-time-report-grid-container">
    <h4 class="header-title">SUM</h4>
    <div class="wrapper-table">
        <table class="table">
            <thead>
                <tr>
                    <th *ngFor="let record of data">{{ record.title }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td *ngFor="let record of data">
                        {{ formatValue(record, 'sum') }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <h4 class="header-title">SUB TOTAL</h4>
    <div class="wrapper-table">
        <table class="table">
            <thead>
                <tr>
                    <th *ngFor="let record of data">{{ record.title }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td *ngFor="let record of data">
                        {{ formatValue(record, 'subTotal') }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
